/* SHOPYTHON enquiry — pick what you bake, roughly how much, and where to reply.

   Loaded by the homepage (05 — Enquire) and /pages/contact. As bakes are picked, the
   "starter line" panel shows the machines those bakes need (in production order), sized
   by the chosen scale. The primary action opens WhatsApp with everything pre-written in
   English; "Prefer email?" reveals an email field and submits Shopify's contact form.
   window.SF_ENQ.preselect()/setLine() are kept so older callers still work. */
(function () {
  "use strict";
  if (window.__sfEnq) return;
  window.__sfEnq = true;

  /* Content pages (.sf-page) use .rise fade-ins, but the observer that adds .in lives in
     scroll-film.js, which only the old film homepage loads. Without this, the enquiry panel
     on /pages/contact stayed at opacity 0. Reveal them here; show at once if unsupported. */
  (function () {
    var els = document.querySelectorAll('.sf-page .rise:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

  var form = document.getElementById('enq');
  var root = document.getElementById('enq3');
  if (!form || !root) return;

  var WA = window.SF_WA || '60178056033';

  /* What each bake needs. Order in the panel follows the production flow in ORDER. */
  var NEEDS = {
    bread:  ['spiral', 'divider', 'proofer', 'deck'],
    pastry: ['spiral', 'sheeter', 'proofer', 'convection'],
    cake:   ['planetary', 'convection', 'decor'],
    cookie: ['planetary', 'convection'],
    pizza:  ['spiral', 'divider', 'deck'],
    pau:    ['spiral', 'sheeter', 'divider', 'proofer'],
    cafe:   ['espresso', 'speed'],
    mill:   ['mill']
  };
  var ORDER = ['mill', 'spiral', 'planetary', 'divider', 'sheeter', 'proofer', 'deck', 'convection', 'speed', 'decor', 'espresso'];
  /* A home baker divides by hand; everything else scales in size, not in kind. */
  var SKIP = { home: { divider: 1 } };

  var bakes = Array.prototype.slice.call(root.querySelectorAll('.bk'));
  var scales = Array.prototype.slice.call(root.querySelectorAll('.sc'));
  var panel = root.querySelector('.e-line');
  var items = {};
  Array.prototype.forEach.call(root.querySelectorAll('#line-list li'), function (li) { items[li.getAttribute('data-k')] = li; });
  var list = document.getElementById('line-list');
  var empty = document.getElementById('line-empty');
  var lineCnt = document.getElementById('line-cnt');
  var bkCnt = document.getElementById('bk-cnt');
  var hint = document.getElementById('enq-hint');
  var mail = document.getElementById('enq-mail');
  var toggle = document.getElementById('mail-toggle');
  var emailIn = document.getElementById('e');
  var countTpl = panel.getAttribute('data-count') || '%n';
  var sizes = (panel.getAttribute('data-sizes') || '').split('|');

  var picked = [];     // bake keys, in tap order
  var scale = null;    // scale button
  var shown = [];      // machine keys currently in the panel
  var LINE = null;

  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function money(n) { return 'RM ' + Math.round(n).toLocaleString('en-MY'); }
  function enOf(el) { return el.getAttribute('data-en'); }
  function bakeEl(k) { for (var i = 0; i < bakes.length; i++) if (bakes[i].getAttribute('data-k') === k) return bakes[i]; }

  function machinesFor() {
    var want = {}, sk = scale ? scale.getAttribute('data-k') : '';
    picked.forEach(function (b) { (NEEDS[b] || []).forEach(function (m) { if (!(SKIP[sk] && SKIP[sk][m])) want[m] = 1; }); });
    return ORDER.filter(function (m) { return want[m]; });
  }

  function render() {
    var next = machinesFor();
    var tag = scale ? sizes[+scale.getAttribute('data-i')] || '' : '';
    ORDER.forEach(function (k) {
      var li = items[k]; if (!li) return;
      var on = next.indexOf(k) !== -1;
      if (on && li.hidden) {
        li.hidden = false;
        li.classList.remove('new'); void li.offsetWidth; li.classList.add('new');
        li.style.animationDelay = (next.indexOf(k) * 0.06) + 's';
      }
      if (!on) { li.hidden = true; li.classList.remove('new'); }
      li.querySelector('.tg').textContent = on ? tag : '';
    });
    /* connector line on every visible item but the first */
    var first = true;
    ORDER.forEach(function (k) { var li = items[k]; if (li && !li.hidden) { li.classList.toggle('nx', !first); first = false; } });
    shown = next;
    empty.hidden = next.length > 0;
    lineCnt.textContent = next.length ? countTpl.replace('%n', next.length) : '';
    bkCnt.textContent = picked.length ? picked.length + ' ✓' : '';
    bkCnt.classList.toggle('on', picked.length > 0);
    if (picked.length && hint) hint.textContent = '';
    sync();
  }

  function sync() {
    document.getElementById('eq-bakes').value = picked.map(function (k) { return enOf(bakeEl(k)); }).join(', ');
    document.getElementById('eq-scale').value = scale ? enOf(scale) : '';
    document.getElementById('eq-line').value = shown.map(function (k) { return enOf(items[k]); }).join(' → ');
  }

  function message() {
    var msg = ['Hi SHOPYTHON, I would like some advice on bakery equipment.', ''];
    if (picked.length) msg.push('We bake: ' + picked.map(function (k) { return enOf(bakeEl(k)); }).join(', '));
    if (scale) msg.push('Scale: ' + enOf(scale) + ' (' + scale.querySelector('small').textContent + ')');
    if (shown.length) msg.push('Suggested line: ' + shown.map(function (k) { return enOf(items[k]); }).join(' → '));
    if (val('n')) msg.push('Name: ' + val('n'));
    if (val('p')) msg.push('Phone: ' + val('p'));
    if (val('m')) msg.push('Note: ' + val('m'));
    if (LINE && LINE.out) {
      msg.push('', 'Line your site suggested:');
      LINE.out.forEach(function (m) { msg.push('• ' + m.k + ' — ' + m.n + ' — ' + (m.p === null ? 'ask us' : money(m.p))); });
    }
    return msg.join('\n');
  }
  function waUrl() { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(message()); }

  function toggleBake(k, force) {
    var el = bakeEl(k); if (!el) return;
    var i = picked.indexOf(k);
    var on = force === undefined ? i === -1 : force;
    if (on && i === -1) picked.push(k);
    if (!on && i !== -1) picked.splice(i, 1);
    el.setAttribute('aria-pressed', String(on));
    render();
  }

  bakes.forEach(function (b) { b.addEventListener('click', function () { toggleBake(b.getAttribute('data-k')); }); });
  scales.forEach(function (s) {
    s.addEventListener('click', function () {
      scale = scale === s ? null : s;
      scales.forEach(function (o) { o.setAttribute('aria-pressed', String(o === scale)); });
      render();
    });
  });

  function needPick() {
    if (picked.length) return false;
    if (hint) hint.textContent = hint.getAttribute('data-pick') || '';
    var grid = root.querySelector('.bks');
    grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    grid.classList.remove('shake'); void grid.offsetWidth; grid.classList.add('shake');
    return true;
  }

  var send = document.getElementById('wa-send');
  if (send) send.addEventListener('click', function () {
    if (needPick()) return;
    window.open(waUrl(), '_blank', 'noopener');
  });

  if (toggle && mail) toggle.addEventListener('click', function () {
    var open = mail.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
    if (emailIn) { emailIn.required = open; if (open) emailIn.focus(); }
  });

  /* Enter in a field would submit the contact form without an email. Unless the
     customer chose email, treat submit as "Send on WhatsApp". */
  form.addEventListener('submit', function (e) {
    var emailMode = mail && mail.classList.contains('open');
    if (!emailMode) {
      e.preventDefault();
      if (needPick()) return;
      window.open(waUrl(), '_blank', 'noopener');
      return;
    }
    if (needPick()) e.preventDefault();
  });

  /* Older callers passed a product; map it onto the closest bake. */
  var MAP = { coffee: 'cafe', espresso: 'cafe', pizza: 'pizza', mill: 'mill', cake: 'cake', sheeter: 'pastry', bread: 'bread', mixer: 'bread', oven: 'bread', proofer: 'bread' };
  window.SF_ENQ = {
    preselect: function (g, v) {
      if (!v) return;
      var key = String(v).toLowerCase();
      for (var k in MAP) { if (key.indexOf(k) !== -1) { toggleBake(MAP[k], true); return; } }
    },
    setLine: function (l) { LINE = l; sync(); }
  };

  render();
})();
